var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"py-4 ma-auto"},[_c('apexchart',{ref:"realTimeLineChart",attrs:{"type":"area","height":204,"options":_vm.chartOptions,"series":_vm.series}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }